// Oral-care suppliers (v1).
import axios from 'axios';
import api, {items} from './client';

export const getAllOralSupplier = () => api.get('/suppliers?page_size=100').then((r) => items(r.data));

export const getOralSupplier = (id) => api.get(`/suppliers/${id}`).then((r) => r.data);

export const getOralSupplierMarkdown = async (content) => {
  if (!content) return '';
  if (/^https?:\/\//.test(content.trim())) {
    const res = await axios.get(content.trim());
    return res.data;
  }
  return content;
};
